import styled from 'styled-components';

export const FinancialButtonsWrap = styled.div`
    display: flex;
    gap: ${(props) => props.theme.spacing[4]};
`;
